<template>
  <div
    :class="getDivClass"
    :messenger_app_id="getMessengerId"
    :page_id="getFbPgId"
    :data-ref="instanceId"
    color="blue"
    size="xlarge"
  ></div>
</template>

<script>
import { mapGetters } from "vuex";
import { initFbSdk } from "@/lib/FacebookSdk";
import Vue from "vue";
import store from "@/store";

export default {
  name: "SendToMessenger",
  components: {},
  data() {
    return {
      instanceId: "123",
      cartId: "123"
    };
  },
  computed: {
    ...mapGetters(["getWidgetsState", "getFbDetails", "getInstanceId"]),
    getDataRef() {
      return this.getInstanceId;
    },
    getMessengerId() {
      return this.getFbDetails.messenger_app_id;
    },
    getFbPgId() {
      return this.getFbDetails.page_id;
    },

    getDivClass() {
      return this.getFbDetails.div_class;
    }
  },
  beforeCreate() {
    initFbSdk(Vue, process.env.VUE_APP_FACEBOOK_CLIENT_ID, store).then(() => {
      this.instanceId = document.querySelector("widget-view").instance_id;
      this.$store.dispatch("setInstanceId", this.instanceId);
    });
  }
};
</script>

<style lang="scss" scoped></style>
